import React, { useContext, useState } from 'react';
import DatePickerModal from './AcceptationModalCalendar/DatePickerModal';
import HourPickerModal from './AcceptationModalCalendar/HourPickerModal';
import DateConfirmModal from './AcceptationModalCalendar/DateConfirmModal';
import { ExpertContext } from '../../../Contexts/contexts';
import { quoteStatus } from '../../../../data/quoteStatus';
import useToast from '../../../Toasts/useToast';
import {
  ToastHeaders,
  ToastThemes,
  ToastMessages,
} from '../../../Toasts/ToastOptions/toastOptions';
import Services from '../../../Services/services';

function QuoteElementExpertAcceptationModal(props) {
  const expertContext = useContext(ExpertContext);
  const enqueueToast = useToast();

  // useState pour montrer ou cacher la modal
  const [showModal, setShowModal] = useState(false);

  // useState pour montrer ou cacher les horaires
  const [showHour, setShowHour] = useState(false);

  // useState pour afficher pop finale
  const [showConfirmation, setShowConfirmation] = useState(false);

  // useState pour la current date selectionnee
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString());

  // useState pour définir si on doit rafraichir les devis et les rdvs
  const [refreshOnClose, setRefreshOnClose] = useState(false);

  // useState pour afficher les rdvs
  const [displayRdvs, setDisplayRdvs] = useState([]);

  const [btnValidate, setBtnValidate] = useState(true);

  function closeModal(e) {
    e.stopPropagation();
    setShowModal(false);
    // enqueueToast('Vous devez proposer 5 rendez-vous', {
    // 	theme: ToastThemes.toastThemes.ERROR_OCCURED,
    // 	header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
    // 	duration: 3000,
    // });
  }

  // Permet de mettre a jour le tableau de rdv grace a selectedDate
  function saveRdv() {
    if (displayRdvs.includes(selectedDate)) {
      return;
    }

    if (displayRdvs.length === 5) return;

    setDisplayRdvs([selectedDate, ...displayRdvs]);

    setSelectedDate(new Date().toISOString());

    setShowHour(false);
  }

  function deleteRdv(index) {
    let tempDisplayRdvs = displayRdvs;
    tempDisplayRdvs.splice(index, 1);

    setDisplayRdvs([...tempDisplayRdvs]);
  }

  async function validateDates() {
    if (displayRdvs.length !== 5) {
      enqueueToast('Vous devez proposer 5 rendez-vous', {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
      return;
    }

    setBtnValidate(false);

    let onError = false;

    try {
      const promises = [];
      displayRdvs.forEach((rdv) => {
        promises.push(
          Services.appointmentService.createAppointment(
            props?.clientExpertRelation?.id,
            rdv
          )
        );
      });

      await Promise.all(promises);

      const updateClientExpertRelation =
        await Services.quoteService.updateClientExpertRelation(
          props?.clientExpertRelation?.id,
          {
            status: quoteStatus.expertAcceptClient,
            statusDate: new Date().toISOString(),
          }
        );

      if (
        updateClientExpertRelation.length > 0 &&
        updateClientExpertRelation[0] === 0
      )
        throw new Error('Cannot update relation');

      await Services.profileService.updateExpertByID(
        expertContext?.expert?.id,
        {
          id: expertContext?.expert?.id,
          nbNewClients: expertContext?.expert?.nbNewClients - 1,
        }
      );
    } catch (error) {
      onError = true;
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }

    if (onError) return;

    try {
      await Services.emailService.sendExpertAcceptClient(
        props?.client?.user?.email,
        'CEC : Veuillez choisir un rendez-vous avec votre expert-comptable',
        props?.client?.firstName,
        props?.client?.lastName
      );
    } catch (error) {
      console.error(error);
    }

    setShowModal(false);
    setShowConfirmation(true);
    setRefreshOnClose(true);
    enqueueToast(ToastMessages.CONFIRM_SUCCESS_APPOINTMENT, {
      theme: ToastThemes.toastThemes.CONFIRM_SUCCESS,
      header: ToastHeaders[ToastThemes.toastThemes.CONFIRM_SUCCESS],
      duration: 3000,
    });
  }

  async function onCancelRequest() {
    setBtnValidate(false);
    let onError = false;

    try {
      await Services.quoteService.updateClientExpertRelation(
        props?.clientExpertRelation?.id,
        {
          status: quoteStatus.rejected,
          statusDate: new Date().toISOString(),
        }
      );
    } catch (error) {
      console.error(error);
    }

    if (onError) return;

    try {
      await Services.emailService.sendExpertRefusedClient(
        props?.client?.user?.email,
        "CEC : L'expert-comptable n'a pas souhaité donner suite à votre demande",
        props?.client?.firstName,
        props?.client?.lastName
      );
    } catch (error) {
      console.error(error);
    }

    expertContext.refreshClientExpertRelations();
    expertContext.refreshAppointments();
  }

  function closeConfirmation() {
    setShowConfirmation(false);

    if (refreshOnClose) {
      expertContext.refreshClientExpertRelations();
      expertContext.refreshAppointments();
    }
  }

  return (
    <>
      <div className="container-client-details">
        <div className="buttons-container">
          <div className="button-refuser" onClick={() => onCancelRequest()}>
            Refuser
          </div>
          <div
            className="element-button pending-status"
            onClick={() => setShowModal(true)}
          >
            Accepter
          </div>
        </div>
      </div>
      {showModal && (
        <div className="container-rdv-modal">
          <div
            className="background-rdv-modal"
            onClick={(e) => closeModal(e)}
          ></div>
          <div className="modal-rdv">
            <div className="expert-calendar">
              <div className="calendar-title-details">
                <h4 className="calendar-title-h4">Dates proposées</h4>
                <div className="calendar-detail">
                  Sélectionnez 5 rendez-vous à proposer à votre client: Une fois
                  que le client aura validé un rendez-vous, vous recevrez
                  directement une notification par mail.
                  <br />
                  Suite à la confirmation, vous recevrez un courriel de
                  confirmation ainsi qu'un rappel de rendez-vous à J-1.
                  <br />
                  Vous pouvez visualiser vos rendez-vous dans votre calendrier.
                </div>
              </div>
            </div>
            {!showHour ? (
              <DatePickerModal
                displayRdvs={displayRdvs}
                selectedDate={selectedDate}
                deleteRdv={(index) => deleteRdv(index)}
                setSelectedDate={(date) => setSelectedDate(date)}
                setShowHour={(value) => setShowHour(value)}
                setShowModal={(value) => setShowModal(value)}
                validate={() => validateDates()}
                btnValidate={btnValidate}
                desiredDays={props?.client?.days?.map((day) => day.name)}
              />
            ) : (
              <HourPickerModal
                selectedDate={selectedDate}
                setSelectedDate={(date) => setSelectedDate(date)}
                setShowHour={(value) => setShowHour(value)}
                saveRdv={() => saveRdv()}
                rdvs={displayRdvs}
              />
            )}
          </div>
        </div>
      )}
      {showConfirmation && (
        <DateConfirmModal closeConfirmation={() => closeConfirmation()} />
      )}
    </>
  );
}

export default QuoteElementExpertAcceptationModal;
